import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Paper, Typography, CssBaseline } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './styles';
import { getPrivacySecurityContent } from '../../actions'
import { scrollTop } from '../../helpers';
import CustomBreadcrum from '../Breadcrum';
import Cookies from 'js-cookie';

export const PaymentTypes = React.memo(() => {
  const classes = useStyles();
  const [data, setData] = useState('');
  const dispatch = useDispatch();
  const theme = useSelector(state => state.theme);
 
  useEffect(() => {
    scrollTop()
    getData();
  }, []);

  const getData = async () => {
    const res = await dispatch(getPrivacySecurityContent('PC015'));
    if (res && res.lstPageContentDetails) {
      const preferredKey = Cookies.get('privateToken') ? 'PaymentOptionsPostLogin' : 'PaymentOptionsPreLogin';
      let filtered = res.lstPageContentDetails.filter(
        (item) => item.contentKey === preferredKey
      );
      if (filtered.length === 0) {
        filtered = res.lstPageContentDetails.filter(
          (item) => item.contentKey === 'PaymentOptionsPostLogin'
        );
      }
      if (filtered.length > 0) {
        const html = filtered[0].contentSubHeader || filtered[0].contentValue || '';
        setData(
          html
            .replaceAll('[privateLabelName]', theme.privateLabelName || '')
            .replaceAll('[customerCareNumber]', theme.customerCareNumber || '')
            .replaceAll('[address]', theme.address || '')
        );
      } else {
        setData('');
      }
    } else {
      setData('');
    }
    scrollTop();
  }

  if (data) {
    return (
       <CssBaseline>
        <Box container="true" maxWidth='xl' className={classes.mainRoot}>
         <Box className={classes.root}>
            <CustomBreadcrum backPage="Home" backPageLink="/" activePage="Payment Options" />
            <Typography className={classes.pageHeading}>Payment Options</Typography>
            <Box className={classes.pageWrapper}>
            <Box className={classes.section}>
            <Typography className={classes.text} dangerouslySetInnerHTML={{ __html: data }}></Typography>
            </Box>
            </Box>
         </Box>
        </Box>
       </CssBaseline>
    )
  } else {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    )
  }
});
